export default __webpack_public_path__ + "static/media/typeoffroad.6b2cfa8d.svg";